import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../firebase.init';

const MyProfile = () => {

    const [user] = useAuthState(auth);

    return (
        <div className="flex justify-center items-center mt-20">
            <div className="card w-96 bg-slate-50 p-8 shadow-xl">
                <h1 className="text-3xl font-semibold">My profile</h1>
                <figure className="px-10 pt-10">
                    {user.photoURL ? <img src={user.photoURL} className="rounded-full w-80" alt="profile" /> : <img src="https://i.ibb.co/XyJjSGb/avatar-icon-design-vector-png-296561.jpg" className="rounded-full w-80" alt="profile" />}
                </figure>
                <div className="card-body items-center text-center">
                    <h2 className="card-title">{user.displayName}</h2>
                    <p>{user?.email}</p>
                </div>
            </div>
        </div>
    );
};

export default MyProfile;